export default __webpack_public_path__ + "assets/high.2ebb82fdcf94efd587247ee5894dd580.mp3";